import React, { Component } from "react";
import { Accessor, ColorX, ZFunc } from "../../../STATIC";
import PropsType from "prop-types";
import { XText } from "../../../_X";
import _ from "lodash";

/**
 * @augments {Component<Props, State>}
 */
class Gridizo extends Component {

  static propTypes = {
    onMounted: PropsType.func,
    data: PropsType.array,
    schema: PropsType.array,
    rowIdAccessor: PropsType.string,
    addOns: PropsType.any,
    headerHeight: PropsType.number,
    rowHeight: PropsType.number,
    cellWidth: PropsType.number,
    firstColumnSticky: PropsType.bool,
    style: PropsType.any,
    headerBackground: PropsType.string,
    rowSeparateColor: PropsType.string,
    fadingEdgeLength: PropsType.number
  }

  static defaultProps = {
    onMounted: null,
    data: [],
    schema: [],
    rowIdAccessor: "_id",
    addOns: {},
    headerHeight: 30,
    rowHeight: 30,
    cellWidth: "auto",
    firstColumnSticky: true,
    style: {},
    headerBackground: ColorX.CSS("pureWhite"),
    rowSeparateColor: ColorX.CSS("bgBlueSeparator"),
    fadingEdgeLength: 0
  }

  constructor(){
    super();
    this.state = {
      mounted: false
    };
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(Gridizo.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), () => {
      if(this.props.onMounted && !this.state.mounted){
        this.props.onMounted({

        });
        this.setState({
          mounted: true
        });
      }
      callback?.();
    });
  }

  /**
   * 
   * @param {import("react-native").NativeSyntheticEvent<import("react-native").NativeScrollEvent>} e 
   */
  _onMainScroll = (e) => {
    this.yaxis.scrollTo({
      x: 0, 
      y: e.nativeEvent.contentOffset.y, 
      animated: false
    });
  }

  renderXCell(ischema, idx){
    let {data, addOns, rowHeight} = this.props;
    let {label, width} = ischema;
    label = ZFunc.IfFuncExec(label, data, addOns);
    let style = {
      backgroundColor: ColorX.CSS("pureWhite"),
      position: "sticky",
      height: rowHeight, 
      minWidth: width ?? "auto",
      top: 0,
      zIndex: 3
    };

    if(idx === 0){
      style = {
        ...style,
        left: 0,
        zIndex: 4
      };
    }

    if(_.isString(label)){
      return (
        <th style={style} key={idx}>
          <XText>
            {label}
          </XText>
        </th>
      );
    }else{
      return (
        <th style={style} key={idx}>
          {label}
        </th>
      );
    }
  }

  renderXHeader(){
    let {schema, headerHeight, headerBackground} = this.props;
    let disSchema = schema;
    return (
      <thead>
        <tr style={{
          width: "100%",
          height: headerHeight, 
          backgroundColor: headerBackground
        }}>
          {_.map(disSchema, (o, i) => {
            return this.renderXCell(o, i);
          })}
        </tr>
      </thead>
    );
  }

  renderCell(doc, ischema, idx, color){
    let {rowHeight, cellWidth, addOns} = this.props;
    let {name, Cell, width} = ischema;
    let field = Accessor.Get(doc, name);
    let display = Cell ? ZFunc.IfFuncExec(Cell, doc, field, addOns) : field;
    let style = {
      height: rowHeight, 
      // width: width ?? cellWidth,
      minWidth: width ?? cellWidth,
      backgroundColor: color
    };
    if(idx === 0){
      style = {
        ...style,
        position: "sticky",
        left: 0,
        zIndex: 2
      };
    }
    if(_.isString(display) || _.isNumber(display)){
      return (
        <td style={style} key={idx}>
          <XText>
            {display}
          </XText>
        </td>
      );
    }else{
      return (
        <td style={style} key={idx}>
          {display}
        </td>
      );
    }
  }

  renderRow(doc, idx){
    let {schema, rowSeparateColor} = this.props;
    let disSchema = schema;
    let color = idx%2 === 0 ? rowSeparateColor : ColorX.CSS("pureWhite");
    return (
      <tr key={idx}>
        {_.map(disSchema, (o, i) => {
          return this.renderCell(doc, o, i, color);
        })}
      </tr>
    );
  }

  renderRows(){
    let {data} = this.props;
    return (
      <tbody>
        { _.map(data, (o, i) => {
          return this.renderRow(o, i);
        })}
      </tbody>
     );
  }

  renderCore(){
    return (
      <table>
        {this.renderXHeader()}
        {this.renderRows()}
      </table>
    );
  }

  render(){
    let {style} = this.props;
    return (
      <div style={{
        ...style,
        textAlign: "center",
        overflow: "auto"
      }}>
        {this.renderCore()}
      </div>
    );
  }

}

export default Gridizo;
